<script>
import { mapGetters } from 'vuex'
// import RolesTabTable from './roles-tab.table.js'
import RolesTabTable from './product-roles-tab.table.js'
// import StaticProcessor from '@lib/processors/static-processor'

export default {
  name: 'ProductRolesTab',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      table: RolesTabTable(this),
    }
  },
  computed: {
    ...mapGetters('me', [
      'showRoleDetails',
    ]),
    listeners() {
      if (this.showRoleDetails) {
        return {
          'row-click': this.onRowClick,
        }
      }

      return {}
    },
  },
  created() {
    // this.table.processor = new StaticProcessor({
    //   component: this,
    //   data: this.product.roles,
    //   disableQueryString: true,
    // })
  },
  methods: {
    onRowClick(row) {
      this.$router.push({
        name: 'role',
        params: {
          productId: this.product.id,
          roleId: row.id,
        },
      })
    },
  },
}
</script>

<template>
  <!-- <div>
    <pre>

    {{ product }}
      </pre>
  </div> -->
  <table-layout
    table-name="product-roles"
    :processor="table.processor"
    :filters="table.filters"
    :columns="table.columns"
    :fragments="false"
    v-on="listeners"
  />
</template>
